import React, { useEffect, useRef, useState } from 'react';
import countriesList from 'iso-3166-1-alpha-2';
import * as Loadings from '../../../../constants/loadings/backoffice/partners';
import { RegexFields } from '../../../../constants/utils/regexFields';
import $ from 'jquery';
import { useDispatch } from 'react-redux';
import * as R from 'ramda';
import { PostalCityInput } from "../../../../_common/postalCityInput";

import Address from '../../../../constants/models/address';
import { CreateEtablissementsByPartnerId, UpdateEtablissementsByPartnerId } from '../../../../actions/backoffice/partners';

export const AddPartnerEstablishment = ({ partnerId, isLoading, selectedEtablissement }) => {
	const dispatch = useDispatch();
	var countries = require("i18n-iso-countries");
	countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));

	const formRef = useRef();

	const initValue = !R.isNil(selectedEtablissement) ? selectedEtablissement : {
		name: '',
		fullyQualifiedName: '',
		vatNumber: '',
		siret: '',
		isEnabled: undefined,
		isRh: undefined,
		partnerDocumentSendingType: undefined,
		billingFrequencyInMonths: 1,
		personalization: undefined,
		setupFee: 0,
		partnerInitialReduction: 0,
		partnerInitialPercentage: 0,
		partnerRecurentReduction: 0,
		partnerRecurentPercentage: 0,
		plateformInitialReduction: 0,
		plateformInitialPercentage: 0,
		plateformRecurentReduction: 0,
		plateformRecurentPercentage: 0,
		addressDataTransferObject: new Address(),
		rhActivationLink: undefined
	};

	function resetForm() {
		formRef.current.classList.remove('was-validated');
		setEtablissementInfo(initValue);
	}
	const [etablissementInfo, setEtablissementInfo] = useState(initValue);

	useEffect(() => {
		if (R.isNil(selectedEtablissement)) {
			resetForm();
		} else {
			setEtablissementInfo({ ...selectedEtablissement });
		}

	}, [selectedEtablissement]);


	return (
		<div className="modal fade px-0" id="AddPartnerEstablishment" aria-labelledby="AddPartnerEstablishmentLabel" aria-hidden="true">
			<div className="modal-dialog modal-lg px-2">
				<div className="modal-content">
					<header className="modal-header">
						{R.isNil(etablissementInfo.id) ? (
							<div className="alert bg-alert-info rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
								<h3 className="sr-only visually-hidden">Add partner Establishment</h3>
								<div className="flex-row align-items-center justify-content-between">
									<div className="h4 text-info text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="AddPartnerEstablishmentLabel">
										ajouter un nouvel Établissement
									</div>
									<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
										<i className="eva eva-close fs-4"></i>
									</button>
								</div>
							</div>
						) : (
							<div className="alert bg-alert-secondary rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
								<h1 className="sr-only visually-hidden">Edit partner</h1>
								<div className="flex-row align-items-center justify-content-between">
									<div className="h4 text-secondary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="EditPartnerLabel">
										Modifier un Établissement
									</div>
									<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
										<i className="eva eva-close fs-4"></i>
									</button>
								</div>
							</div>
						)}
					</header>
					<div className="modal-body scroll-default pt-0">
						<form className="block" noValidate ref={formRef} autoComplete="nope">
							<h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-2">Établissement *</h4>
							<div className="block">
								<div className="form-row">
									<div className="col-md-4">
										<div className="form-group">
											<label className="h6 font-weight-bolder" htmlFor="nomÉtablissement">
												Nom de Établissement
											</label>
											<input required type="text" className="form-control" id="nomÉtablissement" value={etablissementInfo.name} onChange={(e) => setEtablissementInfo({ ...etablissementInfo, name: e.target.value })} />
										</div>
										<div className="form-group">
											<label className="h6 font-weight-bolder" htmlFor="nomÉtablissement">
												Email de facturation
											</label>
											<input required type="text" className="form-control" id="nomÉtablissement" value={etablissementInfo.email} onChange={(e) => setEtablissementInfo({ ...etablissementInfo, email: e.target.value })} />
										</div>
									</div>
									<div className="col">
										<div className="form-group">
											<label className="h6 font-weight-bolder" htmlFor={"Adresseentreprise"}>
												Adresse ligne 1
											</label>
											<input
												required
												type="text"
												className="form-control"
												id={"Adresseentreprise"}
												placeholder="Adresse de l'entreprise"
												value={etablissementInfo.addressDataTransferObject?.addressLine1}
												onChange={(e) => setEtablissementInfo({ ...etablissementInfo, addressDataTransferObject: { ...etablissementInfo.addressDataTransferObject, addressLine1: e.target.value } })}
											/>

											<div className="invalid-feedback">
												<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
												<span className="align-middle text-dark o-70">Ce champ est requis</span>
											</div>
										</div>
										<div className="form-group">
											<label className="label h6 font-weight-bold" htmlFor={"Adresseligne2"}>
												Adresse ligne 2
											</label>
											<input
												type="text"
												className="form-control rounded"
												id={"Adresseligne2"}
												placeholder="(optionnel)"
												value={etablissementInfo.addressDataTransferObject?.addressLine2}
												onChange={(e) => setEtablissementInfo({ ...etablissementInfo, addressDataTransferObject: { ...etablissementInfo.addressDataTransferObject, addressLine2: e.target.value } })}
											/>
										</div>
										<div className="form-row">
											<PostalCityInput
												postalCode={etablissementInfo.addressDataTransferObject?.postalCode}
												city={etablissementInfo.addressDataTransferObject?.city}
												onChange={(updatedAddress) => setEtablissementInfo({ ...etablissementInfo, addressDataTransferObject: { ...etablissementInfo.addressDataTransferObject, postalCode: updatedAddress.postalCode, city: updatedAddress.city } })}
												hasWrapper={false}
												country={etablissementInfo.addressDataTransferObject?.country}
												customClasses={{ city: "form-group col-12 col-sm-6 col-lg", postalCode: "form-group col-12 col-sm-6 col-lg" }}
											/>
											{/* <div className="form-group col-12 col-sm-6 col-lg">
												<label className="h6 font-weight-bolder my-auto" htmlFor={"Postalentreprise"} required>
													Code Postal
												</label>
												<input
													required
													type="text"
													className="form-control"
													id={"Postalentreprise"}
													placeholder="ex: 75001"
													value={etablissementInfo.addressDataTransferObject?.postalCode}
													onChange={(e) => setEtablissementInfo({ ...etablissementInfo, addressDataTransferObject: { ...etablissementInfo.addressDataTransferObject, postalCode: e.target.value } })}
												/>
												<div className="invalid-feedback">
													<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
													<span className="align-middle text-dark o-70">Ce champ est requis</span>
												</div>
											</div>
											<div className="form-group col-12 col-sm-6 col-lg">
												<label className="h6 font-weight-bolder my-auto" htmlFor={"Villeentreprise"} required>
													Ville
												</label>
												<input
													required
													type="text"
													className="form-control"
													id={"Villeentreprise"}
													placeholder="ex: Paris"
													value={etablissementInfo.addressDataTransferObject?.city}
													onChange={(e) => setEtablissementInfo({ ...etablissementInfo, addressDataTransferObject: { ...etablissementInfo.addressDataTransferObject, city: e.target.value } })}
												/>
												<div className="invalid-feedback">
													<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
													<span className="align-middle text-dark o-70">Ce champ est requis</span>
												</div>
											</div> */}
											<div className="form-group col-12 col-sm-6 col-lg">
												<label className="h6 font-weight-bolder my-auto" htmlFor={"Paysentreprise"}>
													Pays
												</label>
												<select className="custom-select" id={"Paysentreprise"} value={etablissementInfo.addressDataTransferObject?.country} onChange={(e) => setEtablissementInfo({ ...etablissementInfo, addressDataTransferObject: { ...etablissementInfo.addressDataTransferObject, country: e.target.value } })}>
													{Object.keys(countriesList.getData()).map((country, idx) => {
														return (
															<option key={idx} value={country}>
																{countries.getName(country, "fr", { select: "official" })}
															</option>
														);
													})}
												</select>
											</div>
										</div>
									</div>
								</div>
								<div className="form-row">
									<div className="col-md">
										<div className="form-group">
											<label className="h6 font-weight-bolder" htmlFor="FullyQualifiedNameInput">
												Raison Sociale
											</label>
											<input required type="text" className="form-control" id="FullyQualifiedNameInput" value={etablissementInfo.fullyQualifiedName} onChange={(e) => setEtablissementInfo({ ...etablissementInfo, fullyQualifiedName: e.target.value })} />
										</div>
									</div>
									<div className="col-md">
										<div className="form-group">
											<label className="h6 font-weight-bolder" htmlFor="TVAÉtablissement">
												TVA
											</label>
											<input required type="text" className="form-control" id="TVAÉtablissement" value={etablissementInfo.vatNumber} onChange={(e) => setEtablissementInfo({ ...etablissementInfo, vatNumber: e.target.value })} pattern={RegexFields.vatNumbers} />
										</div>
									</div>
									<div className="col-md">
										<div className="form-group">
											<label className="h6 font-weight-bolder" htmlFor="SiretÉtablissement">
												SIRET
											</label>
											<input required type="text" className="form-control" id="SiretÉtablissement" value={etablissementInfo.siret} onChange={(e) => setEtablissementInfo({ ...etablissementInfo, siret: e.target.value })} />
										</div>
									</div>
								</div>
							</div>
							<div className="block mt-1">
								<hr className="my-3" />
								<div className={"flex-row align-items-center mt-sm mb-3"}>
									<h5 className={"h4 text-uppercase text-secondary font-weight-bolder mr-auto my-auto"}>Réduction et commissions</h5>
								</div>
								<div className="block p-sm bg-light rounded">
									<div className="row g-2">
										<div className="col-md">
											<h6 className="h5 font-weight-bold text-uppercase o-70">Paiements directement au partenaire</h6>
											<div className="form-row">
												<div className="col">
													<div className="form-group">
														<label className="h6 font-weight-bolder" htmlFor="FraisInt">
															Réduction Dossier
														</label>
														<input required type="text" className="form-control" id="FraisInt" value={etablissementInfo.partnerInitialReduction} onChange={(e) => setEtablissementInfo({ ...etablissementInfo, partnerInitialReduction: e.target.value })} />
													</div>
												</div>
												<div className="col">
													<div className="form-group">
														<label className="h6 font-weight-bolder" htmlFor="CommissionsInt">
															Commission Dossier
														</label>
														<input required type="text" className="form-control" id="CommissionsInt" value={etablissementInfo.partnerInitialPercentage} onChange={(e) => setEtablissementInfo({ ...etablissementInfo, partnerInitialPercentage: e.target.value })} />
													</div>
												</div>
											</div>
											<div className="form-row">
												<div className="col">
													<div className="form-group">
														<label className="h6 font-weight-bolder" htmlFor="FraisInt">
															Réduction Actualisation
														</label>
														<input required type="text" className="form-control" id="FraisInt" value={etablissementInfo.partnerRecurentReduction} onChange={(e) => setEtablissementInfo({ ...etablissementInfo, partnerRecurentReduction: e.target.value })} />
													</div>
												</div>
												<div className="col">
													<div className="form-group">
														<label className="h6 font-weight-bolder" htmlFor="CommissionsInt">
															Commission Actualisation
														</label>
														<input required type="text" className="form-control" id="CommissionsInt" value={etablissementInfo.partnerRecurentPercentage} onChange={(e) => setEtablissementInfo({ ...etablissementInfo, partnerRecurentPercentage: e.target.value })} />
													</div>
												</div>
											</div>
										</div>
										<div className="d-none d-md-flex col-md-auto align-items-center">
											<hr className="divider-vertical h-100" />
										</div>
										<div className="col-md">
											<h6 className="h5 font-weight-bold text-uppercase o-70">Paiements via la plateforme</h6>
											<div className="form-row">
												<div className="col">
													<div className="form-group">
														<label className="h6 font-weight-bolder" htmlFor="FraisExt">
															Réduction Dossier
														</label>
														<input required type="text" className="form-control" id="FraisExt" value={etablissementInfo.plateformInitialReduction} onChange={(e) => setEtablissementInfo({ ...etablissementInfo, plateformInitialReduction: e.target.value })} />
													</div>
												</div>
												<div className="col">
													<div className="form-group">
														<label className="h6 font-weight-bolder" htmlFor="CommissionsExt">
															Commissions Dossier
														</label>
														<input required type="text" className="form-control" id="CommissionsExt" value={etablissementInfo.plateformInitialPercentage} onChange={(e) => setEtablissementInfo({ ...etablissementInfo, plateformInitialPercentage: e.target.value })} />
													</div>
												</div>
											</div>
											<div className="form-row">
												<div className="col">
													<div className="form-group">
														<label className="h6 font-weight-bolder" htmlFor="FraisInt">
															Réduction Actualisation
														</label>
														<input required type="text" className="form-control" id="FraisInt" value={etablissementInfo.plateformRecurentReduction} onChange={(e) => setEtablissementInfo({ ...etablissementInfo, plateformRecurentReduction: e.target.value })} />
													</div>
												</div>
												<div className="col">
													<div className="form-group">
														<label className="h6 font-weight-bolder" htmlFor="CommissionsInt">
															Commission Actualisation
														</label>
														<input required type="text" className="form-control" id="CommissionsInt" value={etablissementInfo.plateformRecurentPercentage} onChange={(e) => setEtablissementInfo({ ...etablissementInfo, plateformRecurentPercentage: e.target.value })} />
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="form-group w-xl-75">
										<label className="h6 font-weight-bolder" htmlFor="frequenceFacturationInt">
											Fréquence de facturation
										</label>
										<select className="form-control custom-select" id="frequenceFacturationInt" aria-label="Default select example" value={etablissementInfo.billingFrequencyInMonths} onChange={(e) => setEtablissementInfo({ ...etablissementInfo, billingFrequencyInMonths: e.target.value })}>
											{[...Array(13)].map((x, i) => {
												if (i === 0) return "";
												return (
													<option key={i} value={i}>
														Tous les {i} mois
													</option>
												);
											})}
										</select>
									</div>
								</div>
							</div>

							<hr className="my-3" />
							<div className="grid grid-md-2 align-items-center my-sm">
								<div className="mr-auto my-auto">
									<h5 className={"h4 text-uppercase text-secondary font-weight-bolder my-auto"}>Actif</h5>
									{/* <p className="o-60 fs-3 mb-0">Activer ou désactiver l'Établissement de ce Établissement</p> */}
								</div>
								<div className="flex-row ml-auto align-items-center">
									{/* <div className="form-inline mb-3"> */}
									<div className="custom-control custom-radio custom-control-inline">
										<input required={R.isNil(etablissementInfo.isEnabled) ? true : false} type="radio" id="OuiStatut" name="Statut" onClick={() => setEtablissementInfo({ ...etablissementInfo, isEnabled: true })} onChange={() => {}} className="custom-control-input" checked={etablissementInfo.isEnabled === true} />
										<label className="custom-control-label" htmlFor="OuiStatut">
											Oui
										</label>
									</div>
									<div className="custom-control custom-radio custom-control-inline mr-0">
										<input required={R.isNil(etablissementInfo.isEnabled) ? true : false} type="radio" id="NonStatut" name="Statut" onClick={() => setEtablissementInfo({ ...etablissementInfo, isEnabled: false })} onChange={() => {}} className="custom-control-input" checked={etablissementInfo.isEnabled === false} />
										<label className="custom-control-label" htmlFor="NonStatut">
											Non
										</label>
									</div>
								</div>
							</div>

							<hr className="my-3" />
							<div className="grid grid-md-2 align-items-center my-sm">
								<div className="mr-auto my-auto">
									<h5 className={"h4 text-uppercase text-secondary font-weight-bolder my-auto"}>Type d'envoi de courrier</h5>
									{/* <p className="o-60 fs-3 mb-0">Activer ou désactiver l'Établissement de ce Établissement</p> */}
								</div>
								<div className="flex-row ml-auto align-items-center">
									{/* <div className="form-inline mb-3"> */}
									<div className="custom-control custom-radio custom-control-inline">
										<input
											required={R.isNil(etablissementInfo.partnerDocumentSendingType) ? true : false}
											type="radio"
											id="OuiPost"
											name="SendByPost"
											onClick={() => setEtablissementInfo({ ...etablissementInfo, partnerDocumentSendingType: "AlwaysSendByPost" })}
											onChange={() => {}}
											className="custom-control-input"
											checked={etablissementInfo.partnerDocumentSendingType === "AlwaysSendByPost"}
										/>
										<label className="custom-control-label" htmlFor="OuiPost">
											Poste pour tous les dossiers
										</label>
									</div>
									<div className="custom-control custom-radio custom-control-inline mr-0">
										<input
											required={R.isNil(etablissementInfo.partnerDocumentSendingType) ? true : false}
											type="radio"
											id="NonPost"
											name="SendByPost"
											onClick={() => setEtablissementInfo({ ...etablissementInfo, partnerDocumentSendingType: "NeverSendByPost" })}
											onChange={() => {}}
											className="custom-control-input"
											checked={etablissementInfo.partnerDocumentSendingType === "NeverSendByPost"}
										/>
										<label className="custom-control-label" htmlFor="NonPost">
											Impression pour tous les dossiers
										</label>
									</div>
									<div className="custom-control custom-radio custom-control-inline mr-0">
										<input
											required={R.isNil(etablissementInfo.partnerDocumentSendingType) ? true : false}
											type="radio"
											id="ChoicePost"
											name="SendByPost"
											onClick={() => setEtablissementInfo({ ...etablissementInfo, partnerDocumentSendingType: "DefineOnAccountCreation" })}
											onChange={() => {}}
											className="custom-control-input"
											checked={etablissementInfo.partnerDocumentSendingType === "DefineOnAccountCreation"}
										/>
										<label className="custom-control-label" htmlFor="ChoicePost">
											Choix pour tous les dossiers
										</label>
									</div>
								</div>
							</div>

							<hr className="my-3" />
							<div className="grid grid-md-2 align-items-center my-sm">
								<div className="mr-auto my-auto">
									<h5 className={"h4 text-uppercase text-secondary font-weight-bolder my-auto"}>RH</h5>
									{etablissementInfo.isRh ? <p className="o-60 fs-2 mb-0">Lien espace entreprise : {etablissementInfo.rhActivationLink || "N/D"} </p> : ""}
								</div>
								<div className="flex-row ml-auto align-items-center">
									{/* <div className="form-inline mb-3"> */}
									<div className="custom-control custom-radio custom-control-inline">
										<input required={R.isNil(etablissementInfo.isRh) ? true : false} type="radio" id="OuiRH" name="RH" onClick={() => setEtablissementInfo({ ...etablissementInfo, isRh: true })} onChange={() => {}} className="custom-control-input" checked={etablissementInfo.isRh === true} />
										<label className="custom-control-label" htmlFor="OuiRH">
											Oui
										</label>
									</div>
									<div className="custom-control custom-radio custom-control-inline mr-0">
										<input required={R.isNil(etablissementInfo.isRh) ? true : false} type="radio" id="NonRH" name="RH" onClick={() => setEtablissementInfo({ ...etablissementInfo, isRh: false })} onChange={() => {}} className="custom-control-input" checked={etablissementInfo.isRh === false} />
										<label className="custom-control-label" htmlFor="NonRH">
											Non
										</label>
									</div>
								</div>
							</div>

							<hr className="my-3" />
							<div className="grid grid-md-2 align-items-center my-sm">
								<div className="mr-auto my-auto">
									<h5 className="h4 text-uppercase text-secondary font-weight-bolder my-auto">Serenita</h5>
								</div>
								<div className="flex-row ml-auto align-items-center">
									{/* <div className="form-inline mb-3"> */}
									<div className="custom-control custom-radio custom-control-inline">
										<input
											required={R.isNil(etablissementInfo.isSerenita) ? true : false}
											type="radio"
											id="OuiSerenita"
											name="Serenita"
											onClick={() => setEtablissementInfo({ ...etablissementInfo, isSerenita: true })}
											onChange={() => {}}
											className="custom-control-input"
											checked={etablissementInfo.isSerenita === true}
										/>
										<label className="custom-control-label" htmlFor="OuiSerenita">
											Oui
										</label>
									</div>
									<div className="custom-control custom-radio custom-control-inline mr-0">
										<input
											required={R.isNil(etablissementInfo.isSerenita) ? true : false}
											type="radio"
											id="NonSerenita"
											name="Serenita"
											onClick={() => setEtablissementInfo({ ...etablissementInfo, isSerenita: false })}
											onChange={() => {}}
											className="custom-control-input"
											checked={etablissementInfo.isSerenita === false}
										/>
										<label className="custom-control-label" htmlFor="NonSerenita">
											Non
										</label>
									</div>
								</div>
							</div>
						</form>
					</div>
					<div className="modal-footer pt-0">
						<button type="button" className="btn btn-faded" data-dismiss="modal" onClick={(e) => resetForm()}>
							Fermer
						</button>
						{isLoading.includes(Loadings.CREATING_ETABLISSEMENT) || isLoading.includes(Loadings.UPDATING_ETABLISSEMENT) ? (
							<button type="button" className="btn btn-info loading-btn show">
								<div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Enregistrer
							</button>
						) : (
							<button
								type="button"
								className="btn btn-info"
								onClick={(e) => {
									e.preventDefault();
									if (formRef.current.checkValidity()) {
										if (R.isNil(etablissementInfo.id)) {
											dispatch(CreateEtablissementsByPartnerId(etablissementInfo, partnerId)).then(() => {
												$(".modal").modal("hide");
												resetForm();
											});
										} else {
											dispatch(UpdateEtablissementsByPartnerId(etablissementInfo, partnerId)).then(() => {
												$(".modal").modal("hide");
												resetForm();
											});
										}
									}
									formRef.current.classList.add("was-validated");
								}}>
								Enregistrer
							</button>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};